function getCoord(e, prop) {
    e = ['touchstart', 'touchmove'].indexOf(e.type) > -1 ? e.touches[0] : e.type == 'touchend' ? e.changedTouches[0] : e;
    return e[prop];
}

export default getCoord;